import { PortalType } from '@ats/api/cm';
import { LogLevel } from '@cm/core/logging';
import { of, shareReplay } from 'rxjs';
import { AppEnvironment } from '../models/app-environment.interface';

export const defaultCulture = {
	code: 'en',
	label: 'English',
	nativeLabel: 'English',
};

export const spCulture = {
	code: 'spculturetest',
	label: 'SP Culture Test',
	nativeLabel: 'SP Culture Test',
};

export const cpCulture = {
	code: 'cpculturetest',
	label: 'CP Culture Test',
	nativeLabel: 'CP Culture Test',
};

export const cultures = [defaultCulture, spCulture, cpCulture];

export const cultures$ = of(cultures).pipe(shareReplay(1));

export const defaultClient = 'cmdemo';

export const ip = [PortalType.InternalPortal];
export const spAndCp = [PortalType.SponsorPortal, PortalType.CandidatePortal];
export const allPortals = [...spAndCp, ...ip];

export const environment: AppEnvironment = {
	production: true,
	beta: false,
	local: false,
	storeDomain: 'MockDomain',
	apiUrl: 'https://someapiurl',
	graphQLUrl: 'https://someapiurl/graphql',
	logging: LogLevel.Trace,
	cpUrl: 'https://cpurl',
	spUrl: 'https://spUrl',
	environment: 'production',
};

export const defaultConfig = (portal: PortalType = PortalType.SponsorPortal) => ({
	baseUrl: environment.apiUrl,
	cpUrl: environment.cpUrl,
	spUrl: environment.spUrl,
	environment: environment.environment,
	env: environment,
	portal,
});
